import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";
import InputMask from "react-input-mask";
import Swal from "sweetalert2";
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';
import Cropper from 'react-easy-crop';
import getCroppedImg from './../Utils/cropImage';

function LoadingModal({ show, message }) {
    if (!show) return null;
    return (
        <div className="loading-modal-overlay">
            <div className="loading-modal-content">
                <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
                <div style={{ marginTop: 15, fontSize: 18 }}>{message}</div>
            </div>
            <style>{`
                .loading-modal-overlay {
                    position: fixed;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.5);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1050;
                }
                .loading-modal-content {
                    background: white;
                    padding: 20px 40px;
                    border-radius: 8px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    box-shadow: 0 0 10px rgba(0,0,0,0.25);
                }
            `}</style>
        </div>
    );
}

function ValidarUsuario() {
    const navigate = useNavigate();
    const chapa = localStorage.getItem("chapa");
    const [dados, setDados] = useState(null);
    const [foto, setFoto] = useState(null);
    const [imagem, setImagem] = useState(null);
    const [imagemBase64, setImagemBase64] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [croppedImagePreview, setCroppedImagePreview] = useState(null);
    const [whatsapp, setWhatsapp] = useState("");
    const [fixo, setFixo] = useState("");
    const [contato, setContato] = useState("");
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(true);
    const [enviando, setEnviando] = useState(false);
    const limparNumero = (valor) => (valor || "").replace(/\D/g, "");

    useEffect(() => {
        if (!chapa) {
            navigate("/arbor/usuario/criar");
            return;
        }
        const carregarDados = async () => {
            try {
                const dadosResp = await api.get(`/usuario/dados/${chapa}`);
                if (dadosResp.data.length > 0) {
                    const d = dadosResp.data[0];
                    setDados(d);
                    setWhatsapp(d.telefone2);
                    setFixo(d.telefone1);
                    setContato(d.telefone3);
                    setEmail(d.email);
                }
                const fotoResp = await api.get(`/usuario/foto/${chapa}`);
                setFoto("data:image/jpeg;base64," + fotoResp.data.foto);
            } catch (err) {
                Swal.fire("Erro", "Falha ao carregar dados", "error");
            } finally {
                setLoading(false);
            }
        };
        carregarDados();
    }, [chapa, navigate]);

    const handleFotoChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => {
            setImagem(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const onCropComplete = async (croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
        if (imagem) {
            try {
                const croppedUrl = await getCroppedImg(imagem, croppedAreaPixels);
                setCroppedImagePreview(croppedUrl);
            } catch (err) {
                console.error("Erro ao gerar preview:", err);
            }
        }
    };

    const gravarFoto = async () => {
        try {
            const croppedUrl = await getCroppedImg(imagem, croppedAreaPixels);
            const response = await fetch(croppedUrl);
            const blob = await response.blob();

            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = async () => {
                const base64Image = reader.result;
                setImagemBase64(base64Image);
                setFoto(base64Image);
            };
        } catch (err) {
            console.error(err);
            Swal.fire("Erro", "Erro ao recortar imagem", "error");
        }
    };

    const salvar = async () => {
        if (!whatsapp.trim()) {
            Swal.fire("Atenção", "Informe o número do WhatsApp", "warning");
            return;
        }

        if (!email.trim()) {
            Swal.fire("Atenção", "Informe o e-mail", "warning");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            Swal.fire("Atenção", "E-mail inválido", "warning");
            return;
        }

        setEnviando(true);
        try {
            const respContato = await api.post(`/usuario/validacao/${chapa}`, {
                telefone1: limparNumero(fixo),
                telefone2: limparNumero(whatsapp),
                telefone3: limparNumero(contato),
                email: email,
            });
            if (respContato.status !== 201) {
                Swal.fire("Erro", "Erro ao salvar os dados de contato", "error");
                return;
            }
        } catch (err) {
            Swal.fire("Erro", "Falha na requisição dos dados de contato", "error");
            return;
        }

        if (imagemBase64) {
            try {
                const respFoto = await api.post(`/usuario/foto/${chapa}`, {
                    tipo: "",
                    imagem: imagemBase64,
                    loja: dados.loja,
                });
                if (respFoto.status !== 201) {
                    Swal.fire("Erro", "Erro ao salvar a foto", "error");
                    return;
                }
            } catch (err) {
                Swal.fire("Erro", "Falha na requisição de envio da foto", "error");
                return;
            }
        }

        try {
            const respIntegracao = await api.post(`/restaurante/${chapa}/integracao`);
            if (respIntegracao.status !== 201) {
                Swal.fire("Erro", "Erro na integração com o restaurante", "error");
                return;
            }

            Swal.fire("Sucesso", "Usuário validado!", "success").then(() => {
                localStorage.removeItem("chapa");
                navigate("/arbor/login");
            });
        } catch (err) {
            Swal.fire("Erro", "Falha na requisição de integração", "error");
        } finally {
            setEnviando(false);
        }
    };

    if (loading) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center vh-100">
                <div className="spinner-border text-primary mb-3" role="status"></div>
                <strong>Carregando dados...</strong>
            </div>
        );
    }

    return (
        <div className="d-flex flex-column min-vh-100">
            <Menu modulo="NOVO" />

            <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                <div className="container p-4 shadow-sm bg-light rounded" style={{ maxWidth: 500 }}>
                    <h4 className="text-center mb-3">Validação de Dados</h4>

                    <div className="text-center mb-3">
                        <img
                            src={foto}
                            alt="Foto"
                            className="rounded-circle"
                            width={120}
                            height={120}
                        />
                        <div className="mt-2">
                            <button
                                type="button"
                                className="btn btn-dark btn-sm"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                            >
                                Tirar nova foto
                            </button>
                        </div>
                    </div>

                    <label>WhatsApp:</label>
                    <InputMask
                        mask="(99) 99999-9999"
                        className="form-control"
                        value={whatsapp}
                        onChange={(e) => setWhatsapp(e.target.value)}
                    />

                    <label>Telefone Fixo:</label>
                    <InputMask
                        mask="(99) 9999-9999"
                        className="form-control"
                        value={fixo}
                        onChange={(e) => setFixo(e.target.value)}
                    />

                    <label>Contato:</label>
                    <InputMask
                        mask="(99) 99999-9999"
                        className="form-control"
                        value={contato}
                        onChange={(e) => setContato(e.target.value)}
                    />

                    <label>E-mail:</label>
                    <input
                        type="email"
                        className="form-control"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <button className="btn btn-success mt-3 w-100" onClick={salvar} disabled={enviando}>
                        Confirmar e Finalizar
                    </button>
                </div>
            </div>

            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Tirar Foto</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => {
                                    setImagem(null);
                                    setCroppedImagePreview(null);
                                }}
                            ></button>
                        </div>
                        <div className="modal-body">
                            {imagem ? (
                                <>
                                    <div style={{ position: 'relative', width: '100%', height: 300 }}>
                                        <Cropper
                                            image={imagem}
                                            crop={crop}
                                            zoom={zoom}
                                            aspect={1}
                                            onCropChange={setCrop}
                                            onZoomChange={setZoom}
                                            onCropComplete={onCropComplete}
                                        />
                                    </div>
                                    {croppedImagePreview && (
                                        <div className="text-center mt-3">
                                            <p className="mb-1">Pré-visualização:</p>
                                            <img
                                                src={croppedImagePreview}
                                                alt="Pré"
                                                style={{ width: 120, height: 120, borderRadius: '50%', border: '2px solid #ccc' }}
                                            />
                                        </div>
                                    )}
                                </>
                            ) : (
                                <img className="img-fluid" alt="Foto atual" src={foto} />
                            )}
                        </div>
                        <div className="modal-footer">
                            <input type="file" accept="image/*" capture="user" onChange={handleFotoChange} />
                            <button className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            {imagem && (
                                <button className="btn btn-success" data-bs-dismiss="modal" onClick={gravarFoto}>
                                    Confirmar Foto
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <LoadingModal show={enviando} message="Aguarde... Enviando dados" />
            <Footer />
        </div>
    );
}

export default ValidarUsuario;
